import { createFileRoute } from "@tanstack/react-router";

import { RouteErrorFallback } from "@/components/error-message";
import { AdminPending } from "@/features/admin/components/admin-route-components";
import { adminMarkersQueryOptions } from "@/features/admin/lib/markers-queries";
import { adminSeoHead } from "@/lib/seo";

export const Route = createFileRoute("/_app/_authenticated/admin/markers")({
  head: () => adminSeoHead("Markers"),
  loader: ({ context }) =>
    context.queryClient.query({ ...adminMarkersQueryOptions, staleTime: "static" }),
  pendingComponent: AdminPending,
  errorComponent: RouteErrorFallback,
});
